import { getDefaultQuotationDocState } from "../components/QuotationPricingSection/QuotationPricingSection";
import { formatDestinationAddressBlock, formatOriginAddressBlock } from "./quotationRouteLines";
import { suggestTruckFromCft } from "./suggestedTruckFromCft";

function nToStr(v) {
  if (v == null || v === "") return "";
  return typeof v === "number" ? String(v) : String(v);
}

function numOrZero(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

/**
 * When opening pricing, the DB may not yet have load / suggested truck (only set on save).
 * Align the form with total CFT the same way the CFT page summary does.
 */
function deriveTruckFieldsFromTotalCft(quotation, suggestedTruckSize, loadDescription) {
  const totalCft = numOrZero(quotation.totalCft);
  if (totalCft <= 0) {
    return { suggestedTruckSize, loadDescription };
  }
  const hint = suggestTruckFromCft(totalCft);
  let nextSuggested = (suggestedTruckSize || "").trim();
  let nextLoad = (loadDescription || "").trim();
  if (!nextSuggested && hint.label) {
    nextSuggested = hint.label;
  }
  if (!nextLoad && hint.loadDescription) {
    nextLoad = hint.loadDescription;
  }
  return { suggestedTruckSize: nextSuggested, loadDescription: nextLoad };
}

export function getPricingFormStateFromQuotation(quotation) {
  const base = getDefaultQuotationDocState();
  const rawSuggested = quotation.suggestedTruckSize || "";
  const rawLoad = quotation.loadDescription || "";
  const { suggestedTruckSize, loadDescription } = deriveTruckFieldsFromTotalCft(
    quotation,
    rawSuggested,
    rawLoad
  );
  const quotationDoc = {
    ...base,
    customerName: quotation.customerName || "",
    quotationRefNo: quotation.quotationRefNo || "",
    quotationDate: quotation.quotationDate || base.quotationDate,
    fromLocation:
      (quotation.fromLocation && String(quotation.fromLocation).trim()) ||
      formatOriginAddressBlock(quotation) ||
      quotation.originCity ||
      "",
    toLocation:
      (quotation.toLocation && String(quotation.toLocation).trim()) ||
      formatDestinationAddressBlock(quotation) ||
      quotation.destinationCity ||
      "",
    distanceKm: nToStr(quotation.distanceKm),
    suggestedTruckSize,
    loadDescription,
    totalCft: nToStr(quotation.totalCft),
    declaredLuggageValue: nToStr(quotation.declaredLuggageValue),
    carrierRiskPercent:
      quotation.carrierRiskPercent != null && quotation.carrierRiskPercent !== ""
        ? String(quotation.carrierRiskPercent)
        : "2",
    gstPercent: quotation.gstPercent != null ? String(quotation.gstPercent) : base.gstPercent,
    gstAmount: quotation.gstAmount != null && quotation.gstAmount !== "" ? String(quotation.gstAmount) : "",
    transportationChargesAmount: nToStr(quotation.transportationChargesAmount),
    carTransportationChargesAmount: nToStr(quotation.carTransportationChargesAmount),
    loadingChargesAmount: nToStr(quotation.loadingChargesAmount),
    unloadingChargesAmount: nToStr(quotation.unloadingChargesAmount),
    unpackingRearrangingChargesAmount: nToStr(quotation.unpackingRearrangingChargesAmount),
    shuttleLongCarryEscortChargesAmount: nToStr(quotation.shuttleLongCarryEscortChargesAmount),
    carrierRiskChargesAmount: nToStr(quotation.carrierRiskChargesAmount),
    paymentTerms: quotation.paymentTerms || base.paymentTerms,
    quotationIntro: quotation.quotationIntro || base.quotationIntro,
    quotationPdfNote: quotation.quotationPdfNote || "",
    handymanServicesNote: quotation.handymanServicesNote || "",
    extraHandlingAndStorageNote: quotation.extraHandlingAndStorageNote || "",
    localUnionOctroiNote: quotation.localUnionOctroiNote || "",
    validityDays: nToStr(quotation.validityDays),
    moveWindowDays: nToStr(quotation.moveWindowDays),
    transitTimeNote: quotation.transitTimeNote || "",
    termsAndConditionsText:
      Array.isArray(quotation.termsAndConditions) && quotation.termsAndConditions.length
        ? quotation.termsAndConditions.join("\n")
        : base.termsAndConditionsText,
    quotationExtraNote1: quotation.quotationExtraNote1 || "",
    quotationExtraNote2: quotation.quotationExtraNote2 || "",
  };
  return { quotationDoc };
}
